<template>
    <div class="col-12 mb-2" v-if="loaded">
        <h2 class="text-uppercase col-12">{{ $t('teamSetup.officials') }}</h2>
        <template v-for="(official, key) in score.officials" :key="key">
            <div class="col g-0 column-gap-1 row mb-1" v-if="official">
                <div class="col bg-bb5-yellow px-1 py-2">{{ shortName(official) }} @{{ $t(`officials.${key}`) }}</div>
                <button @click="deleteOfficial(key)" class="col-1 btn-danger m-0 py-2">x</button>
            </div>
        </template>
    </div>
    <div class="col-12">
        <div class="row column-gap-1 g-0">
            <h3 class="col-12">{{ $t('officials.addOfficial') }}</h3>
            <input class="col-8 p-1" v-model="newOfficial.name" :placeholder="$t('officials.name')" />
            <select class="col-2" v-model="newOfficial.role">
                <option value="">{{ $t('officials.selectRole') }}</option>
                <option v-for="role in availableRoles" :key="role" :value="role">
                    {{ $t(`officials.${role}`) }}
                </option>
            </select>
            <button @click="saveOfficial" class="col btn btn-bb5-black m-0" :disabled="officialCount">+</button>
        </div>
        <div class="row column-gap-1 g-0">
            <h3 class="col-12">{{ $t('officials.addOfficial') }}</h3>
            <select v-model="newOfficial.name" id="player-select" class="col-8">
                <option value="" disabled>{{ $t('officials.selectOffical') }}</option>
                <option v-for="official in filterOfficials()" :key="official.id" :value="official.name">
                    {{ official.name }}
                </option>
            </select>
            <select v-model="newOfficial.role" class="col-2">
                <option value="">{{ $t('officials.selectRole') }}</option>
                <option v-for="role in availableRoles" :key="role" :value="role">
                    {{ $t(`officials.${role}`) }}
                </option>
            </select>

            <!-- Add Button -->
            <button @click="addOfficial()" :disabled="officialCount"
                class="col btn btn-bb5-black m-0">+</button>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import { saveOfficial, loadAllOfficials } from "@/services/indexedDB";
import core from "@/mixins/Core";

export default {
    data() {
        return {
            newOfficial: {
                name: "",
                role: "",
            },
            officials: [],
            selectedOffical: '',
            loaded: false,
            allRoles: [
                "homePlateOfficial",
                "firstBaseOfficial",
                "secondBaseOfficial",
                "thirdBaseOfficial",
                "tableOfficial",
            ],
        };
    },
    async mounted() {
        this.fetchOfficials();
        this.loaded = true;
    },
    mixins: [core],
    computed: {
        ...mapState(['score']),
        availableRoles() {
            // Entferne bereits gesetzte Rollen aus `allRoles`
            return this.allRoles.filter((role) => !this.score.officials[role]);
        },
        officialCount() {
            const filteredOfficials = Object.keys(this.score.officials).filter((key) => {
                if (!this.score.officials[key]) {
                    delete this.score.officials[key]; // Entferne leere Einträge
                    return false;
                }
                return true;
            });

            // Überprüfe, ob die Anzahl der Offiziellen kleiner als 5 ist
            return filteredOfficials.length >= 5;
        },
    },
    methods: {
        async fetchOfficials() {
            this.officials = await loadAllOfficials();
        },
        async addOfficial() {
            if (!this.newOfficial.name || !this.newOfficial.role) {
                alert(this.$t('officials.requiredFields'));
                return;
            }
            this.score.officials[this.newOfficial.role] = this.newOfficial.name;
            this.newOfficial = { name: "", role: "" }; // Reset the form
        },
        async saveOfficial() {
            if (!this.newOfficial.name || !this.newOfficial.role) {
                alert(this.$t('officials.requiredFields'));
                return;
            }
            const official = {
                id: Date.now(),
                name: this.newOfficial.name,
            };
            await saveOfficial(official);
            this.officials.push(official);
            this.score.officials[this.newOfficial.role] = this.newOfficial.name;
            this.newOfficial = { name: "", role: "" }; // Reset the form
        },
        deleteOfficial(official) {
            if (confirm(this.$t('officials.confirmDelete'))) {
                this.score.officials[official] = ''
            }
        },
        filterOfficials() {
            // Filtere die Offiziellen, deren Namen bereits in `this.score.officials` existieren
            return this.officials.filter((official) => {
                return !Object.values(this.score.officials).includes(official.name);
            });
        },
    },
};
</script>

<style scoped>
.container {
    padding: 20px;
}

button {
    margin-left: 10px;
}
</style>